cafm.setup = {
    winName: "",
    winPass: "",
    winDomain: "",
    setupDivName: "#setupDiv",
    targetPanel: function () {
        return $(cafm.setup.setupDivName);
    },
    bind: function (sData) {
        var targetPanel = cafm.setup.targetPanel();
        targetPanel.bindViewModel({
            viewModel: sData
        });
        targetPanel.prepareForm();
        $('{0} .cafmPb'.format(cafm.setup.setupDivName)).each(function (i, el) {
            $('.k-link', el).first().click();
        });
    },
    load: function () {
        cafm.actions.execute({
            url: cafm.url.api('Configuration/LoadSetup'),
            requestDelay: 500,
            method: 'GET',
            loaderSelector: cafm.views.mainViewSelector,
            loaderText: cafm.res.str.TextLoadingSetup,
            statusCodeFuncs: {
                200: function (r, s, m) {
                    cafm.setup.bind(r);
                    $('#sub-header-toolbar').show();
                }
            }
        });
    },
    showMain: function () {
        cafm.setup.load();
        cafm.setup.targetPanel().show();
    },
    captureAuthentication: function () {
        var credDiv = $('#userCredentials');
        $('input', credDiv).each(function (i, e) {
            $(e).val('');
        });
        credDiv.show();
        credDiv.showMessage({
            Title: cafm.res.str.MessageProvideAdminCreds
        });

        var kw = credDiv.data("kendoWindow");
        if (!kw) {
            var tb = $("#credentials-toolbar");
            kw = $(credDiv).kendoWindow({
                actions: ["Close"],
                draggable: false,
                modal: true,
                resizable: false,
                title: cafm.res.str.TitleAdminCredsRequired,
                width: 440,
                height: 360,
                actions: {},
                activate: function () {

                    cafm.util.positionWindowButtons({
                        container: tb
                    });

                    $("button", tb).off('click').on('click', function () {
                        cafm.setup.winName = $('#txtUserName', credDiv).val();
                        cafm.setup.winPass = $('#txtUserPassword', credDiv).val();
                        cafm.setup.winDomain = $('#txtUserDomain', credDiv).val();
                        var input = {
                            Name: cafm.setup.winName,
                            Password: cafm.setup.winPass,
                            Domain: cafm.setup.winDomain
                        };
                        cafm.actions.execute({
                            elementId: 'userCredentials',
                            url: cafm.url.api('Configuration/ImpersonateUser'),
                            values: input,
                            preventValidationMessage: true,
                            keepMessages: true,
                            loaderSelector: "#userCredentials",
                            statusCodeFuncs: {
                                200: function () {
                                    cafm.setup.showMain();
                                    kw.close();
                                }
                            }
                        });
                    });
                }
            }).data("kendoWindow");

            kw.center();
            kw.open();
        }

    },
    init: function () {
        $('#sub-header-toolbar').hide();
        cafm.setup.captureAuthentication();
    },
    setupLicenceControl: function (divId, lic) {
        var div = $('#' + divId);
        $("input[type='checkbox']", div).css('readonly', 'readonly')
        $("span[class='chk']", div).setChecked(lic.IsLicensed, false).setCheckboxDisabled(true);
        $("input[id*='LicensedFor']", div).val(lic.LicensedFor);
        if (lic.IsLicensed) {
            $("span[id*='AuthCode'],span[id*='UniqLicCode'],button[type='button']", div).hide();
            $("span[id*='LicFor']", div).show();
        } else {
            $("span[id*='AuthCode'],span[id*='UniqLicCode'],button[type='button']", div).show();
            $("span[id*='LicFor']", div).hide();
        }
        //if (hasLicence == false) {
        $("button", div).on('click', function () {
            var ac = $("input[data-bind*='AuthorisationCode']", div).val();
            var input = {
                Data: {
                    AuthorisationCode: ac
                },
                Authentication: {
                    Name: cafm.setup.winName,
                    Password: cafm.setup.winPass,
                    Domain: cafm.setup.winDomain
                }
            };
            cafm.actions.execute({
                url: cafm.url.api('Configuration/RegisterLicence'),
                values: input,
                loaderSelector: cafm.setup.setupDivName,
                loaderText: cafm.res.str.TextRegisteringLicense,
                statusCodeFuncs: {
                    200: function (r, s, m) {
                        if (r.IsLicensed) {
                            cafm.msg.showMessageInWindow({
                                title: cafm.res.str.MessageLicenceRegistered,
                                type: cafm.enums.MessageType.Success
                            });
                        } else {
                            cafm.msg.showMessageInWindow({
                                title: cafm.res.str.MessageLicenceRegistrationFailed,
                                type: cafm.enums.MessageType.Error
                            });
                        }
                        cafm.setup.setupLicenceControl(divId, r);
                    }
                }
            });
        });
        //}
    },
    setUpToolbar: {
        save: function () {
            var vm = cafm.setup.targetPanel().getViewModel();
            cafm.actions.execute({
                url: cafm.url.api('Configuration/ProcessSetup'),
                values: {
                    Data: vm,
                    Authentication: {
                        Name: cafm.setup.winName,
                        Password: cafm.setup.winPass,
                        Domain: cafm.setup.winDomain
                    }
                },
                loaderSelector: cafm.setup.setupDivName,
                loaderText: cafm.res.str.ProcessingSetup,
                requestDelay: 500,
                statusCodeFuncs: {
                    200: function (r, s, m) {
                        cafm.msg.showMessageInWindow({
                            title: cafm.res.str.MessageSetupProcessed,
                            type: cafm.enums.MessageType.Success
                        });
                        cafm.url.set();
                    }
                }
            });
        },
        cancel: function () {
            cafm.url.set();
        }
    },
    parentChildCombo: {
        setup: function (d) {
            var div = $(d);
            var pItem = $('.pccParent', div);
            var pUrl = pItem.data('url');
            var pTKey = pItem.data('textkey');
            var pVKey = pItem.data('valuekey');
            var cItems = $('.pccChild', div);
            pItem.kendoComboBox({
                dataTextField: pTKey,
                dataValueField: pVKey,
                dataSource: {
                    transport: {
                        read: {
                            url: pUrl
                        }
                    }
                }
            });
            cItems.each(function (e, i) {
                var cItem = $(i);
                var cUrl = cItem.data('url');
                var cTKey = cItem.data('textkey');
                var cVKey = cItem.data('valuekey');
                var childInputParam = cItem.data('input');
                var inputData = {};
                inputData[childInputParam] = function () {
                    var v = pItem.data('kendoComboBox').value();
                    return isUndefined(v) ? '' : v;
                }
                cItem.kendoComboBox({
                    dataTextField: cTKey,
                    dataValueField: cVKey,
                    dataSource: {
                        transport: {
                            read: {
                                url: cUrl,
                                data: inputData
                            }
                        }
                    }
                });
            });
            pItem.on('change', function () {
                cItems.each(function (e, i) {
                    $(i).data('kendoComboBox').dataSource.read()
                });
            });
        }
    }
}